import LiveClock from 'components/common/LiveClock'
import TemplateForm from 'components/template/TemplateForm';
import React from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { templatesSelector } from 'slices/templateSlice';
import { useTranslation } from 'react-i18next';

const CreateTemplate = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { templatesListPage, loader, error } = useSelector(templatesSelector);

    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> {t("common.back")}
                    </button>
                    <h2 className={`main_heading`}>{t("templates.createTemplates")}</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            <TemplateForm loader={loader} />
        </div>
    )
}

export default CreateTemplate